<!-- src/components/admin/users/CrmAccessToggle.vue -->
<template>
  <div class="d-inline-flex justify-center align-center">
    <v-switch
      v-model="enabled"
      :loading="saving"
      dense
      hide-details
      class="ma-0 pa-0"
      @change="toggle"
    />
  </div>
</template>
<script>
export default {
  name: "CrmAccessToggle",
  props: { user: { type: Object, required: true } },
  data() { return { saving: false, enabled: !!this.user.crm_access_enabled }; },
  watch: {
    // Sync when the parent row reloads with the backend value (после fetch).
    "user.crm_access_enabled"(val) { this.enabled = !!val; },
  },
  methods: {
    async toggle(val) {
      this.saving = true;
      try {
        await this.$store.dispatch("crm/updateUserAccess", { id: this.user.id, enabled: val });
        // Keep the parent row in sync so the value persists без перезагрузки.
        this.$set(this.user, "crm_access_enabled", val);
        this.$emit("updated", { id: this.user.id, enabled: val });
        this.$notify(this.$t("crm.toast.user_access_updated"), "", "success", 2500);
      } catch (err) {
        this.enabled = !val; // revert local switch on failure
        const d = (err.response && err.response?.data) || {};
        this.$notify(this.$t("crm.toast.network_error"), d.error || "", "error");
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>
